

class CustomSlideCart extends HTMLElement {
    
    constructor() {
        super();

        this.cartItems = this.querySelector('.csc-drawer__items');
        this.cartTotal = this.querySelector('.csc-drawer__footer-total .csc-drawer__footer-calc__row-summary');
        this.cartSubtotal = this.querySelector('.csc-drawer__footer-subtotal .csc-drawer__footer-calc__row-summary');
        this.cartDiscountContainer = this.querySelector('.csc-drawer__footer-discount');
        this.cartDiscount = this.querySelector('.csc-drawer__footer-discount .csc-drawer__footer-calc__row-summary');
        this.overlay = this.querySelector('.csc-overlay');
        this.closeButton = this.querySelector('.csc-drawer__header-close');
        this.submit = this.querySelector('.csc-drawer__footer-checkout-button');
        this.cartCount = document.querySelector('[data-cart-count-bubble]');
        this.cartEmpty = this.querySelector('.csc-drawer__empty');
        this.loadingIcon = this.querySelector('.csc-drawer__footer-checkout-button-loading');
        this.submitText = this.querySelector('.csc-drawer__footer-checkout-button-checkout');
        this.cartEmptyText = this.querySelector('[data-cart-empty]')

        this.shippingStatus = this.querySelector('[data-shipping-status]')
        this.shippingFull = this.querySelector('[data-shipping-full]')
        this.shippingPartial = this.querySelector('[data-shipping-partial]')
        this.shippingProgressAmount = this.querySelector('[data-shipping-progress]')
        this.shippingProgressContainer = this.querySelector('.progress-bar')

        this.slideCartButton = document.querySelector('.site-header__cart');

        this.slideCartButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            this.toggleVisibility();
        });

        this.overlay.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.toggleVisibility();
        });

        this.closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.toggleVisibility();
        });
        this.addToCartButtons = document.querySelectorAll('.js-add-to-cart');
        this.formButtons = document.querySelectorAll('.product-form__cart-submit');

        this.addToCartButtons.forEach(button => {
            button.addEventListener('click', async (e) => {
                e.preventDefault();
                e.stopPropagation();
                await this.addItem(button);
                this.toggleVisibility();
                await this.refreshCart();
            });
        });

        this.formButtons.forEach(button => {
            button.addEventListener('click', async (e) => {
                e.preventDefault();
                e.stopPropagation();
                await this.addItem(button, true);
                this.toggleVisibility();
                await this.refreshCart();
            });
        });

        this.submit.addEventListener('click', async (e) => {
            e.preventDefault();
            e.stopPropagation();

            this.submitText.classList.add('visually-hidden');
            this.loadingIcon.classList.remove('visually-hidden');
            window.location.href = '/checkout';
            this.loadingIcon.classList.add('visually-hidden');
            this.submitText.classList.remove('visually-hidden');
        });
        this.refreshCart();
    }


    async addItem(button, isForm = false) {
        if (!isForm) {
            let productId = button.dataset.productId;

            return await fetch('/cart/add.js', { 
                method: 'POST', 
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: productId,
                    quantity: 1
                })
            });
        } else {
            let form = document.querySelector('.product-form-product-template, .product-form-product-template-alternate');
            const data = new FormData(form);

            return await fetch('/cart/add.js', { method: 'POST', body: data });
        }
    }

    toggleVisibility() {
        this.classList.toggle('custom-slide-cart__active');
        document.querySelector('body').classList.toggle('csc-active');
        document.querySelector('html').classList.toggle('csc-active');
    }

    async refreshCart() {
        let response = await fetch('/cart?view=json');
        let data = await response.json();

        let { items_subtotal_price, total_price, total_discount, items } = data;
        this.cartTotal.innerHTML = Shopify.formatMoney(total_price, theme.moneyFormat);
        this.cartSubtotal.innerHTML = Shopify.formatMoney(items_subtotal_price, theme.moneyFormat);
        this.cartDiscount.innerHTML = Shopify.formatMoney(total_discount, theme.moneyFormat);


        if (items.length === 0) {
            this.cartEmpty.classList.remove('visually-hidden');
            this.cartItems.classList.add('visually-hidden');
        } else {
            this.cartEmpty.classList.add('visually-hidden');
            this.cartItems.classList.remove('visually-hidden');
        }

        this.cartItems.innerHTML = '';

        items.map(item => {
            let { featured_image, product, options_with_values, quantity, price, compareAtPrice, variant_id, url, properties } = item;
            quantity = parseInt(quantity);
            let priceHTML = `
                <div class="csc-drawer__item-controls--price">${Shopify.formatMoney(price, theme.moneyFormat)}</div>
                <div class="csc-drawer__item-controls--price-compare ${compareAtPrice > 0 ? ``: 'visually-hidden'}">
                    ${Shopify.formatMoney(compareAtPrice, theme.moneyFormat)}
                </div>
            `;
            
            let newCartItemHTML = `
                <custom-slide-cart-item class="csc-drawer__item" data-id="${variant_id}"">
                    <img class="csc-drawer__item-image" src="${featured_image}" alt="${product.title}" />
                    <div class="csc-drawer__item-description">
                        <a href="${url}" class="csc-drawer__item-description--title">${product.title}</a>
                        <div class="csc-drawer__item-description--options">
                            ${options_with_values.map(option => `<div class="csc-drawer__item-description--option">${option.name}: ${option.value}</div>`).join('')}
                        </div>
                        <div class="csc-drawer__item-controls--prices">
                            ${priceHTML}
                        </div>
                        <div class="csc-drawer__item-description--quantity">
                            <div class="csc-drawer__item-description--quantity-minus">-</div>
                            <input type="text"
                                name="quantity" value="${quantity}" min="1" pattern="[0-9]*"
                                class="csc-drawer__item-description--quantity-amount" 
                                data-quantity-input
                                max-length="3"
                            />  
                            <div class="csc-drawer__item-description--quantity-plus">+</div>
                        </div>
                    </div>
                    <div class="csc-drawer__item-controls">
                        <div class="csc-drawer__item-controls--remove"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 40 40"><path d="M23.868 20.015L39.117 4.78c1.11-1.108 1.11-2.77 0-3.877-1.109-1.108-2.773-1.108-3.882 0L19.986 16.137 4.737.904C3.628-.204 1.965-.204.856.904c-1.11 1.108-1.11 2.77 0 3.877l15.249 15.234L.855 35.248c-1.108 1.108-1.108 2.77 0 3.877.555.554 1.248.831 1.942.831s1.386-.277 1.94-.83l15.25-15.234 15.248 15.233c.555.554 1.248.831 1.941.831s1.387-.277 1.941-.83c1.11-1.109 1.11-2.77 0-3.878L23.868 20.015z" class="layer"/></svg></div>
                    </div>
                </custom-slide-cart-item>
            `;
            this.cartItems.innerHTML += newCartItemHTML;

        }).join('');

        this.cartDiscount.innerHTML = '-' + Shopify.formatMoney(parseInt(total_discount), theme.moneyFormat);
        if (total_discount > 0) {
            this.cartDiscountContainer.classList.remove('visually-hidden');
        } else {
            this.cartDiscountContainer.classList.add('visually-hidden');
        }
        this.cartTotal.innerHTML = Shopify.formatMoney(total_price, theme.moneyFormat);
        this.cartSubtotal.innerHTML = Shopify.formatMoney(items_subtotal_price, theme.moneyFormat);

        let newQuantity = data.item_count;
        if (newQuantity > 0) {
            this.cartCount.classList.remove('hide');
            this.cartCount.textContent = newQuantity;
            this.cartEmptyText.classList.add('visually-hidden')
            this.shippingStatus.classList.remove('visually-hidden')
        } else {
            this.cartCount.classList.add('hide');
            this.cartCount.textContent = '';
            this.cartEmptyText.classList.remove('visually-hidden')
            this.shippingStatus.classList.add('visually-hidden')
        }

        let freeShippingThreshold = parseInt(this.shippingProgressContainer.dataset.max);
        let currentTotal = parseInt(total_price);
        

        if (currentTotal >= freeShippingThreshold) {
            this.shippingFull.classList.remove('visually-hidden');
            this.shippingPartial.classList.add('visually-hidden');
        } else {
            this.shippingFull.classList.add('visually-hidden');
            this.shippingPartial.classList.remove('visually-hidden');
            let progress = freeShippingThreshold - currentTotal;
            this.shippingProgressAmount.textContent = Shopify.formatMoney(progress, theme.moneyFormat);
        }
        


        return data;
    }
}
customElements.define('custom-slide-cart', CustomSlideCart);

class CustomSlideCartItem extends HTMLElement {
    constructor() {
        super();

        this.quantityAmount = this.querySelector('.csc-drawer__item-description--quantity-amount');

        this.quantitySelectorPlus = this.querySelector('.csc-drawer__item-description--quantity-plus');
        this.quantitySelectorMinus = this.querySelector('.csc-drawer__item-description--quantity-minus');
        this.removeButton = this.querySelector('.csc-drawer__item-controls--remove');
        this.cart = document.querySelector('custom-slide-cart');

        this.quantitySelectorPlus.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            let quantity = parseInt(this.quantityAmount.value);
            this.updateQuantity(quantity + 1);
        });

        this.quantitySelectorMinus.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            let quantity = parseInt(this.quantityAmount.value);
            this.updateQuantity(quantity - 1);
        });

        this.removeButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            this.remove();
        });

        this.quantityAmount.addEventListener('change', (e) => {
            e.preventDefault();
            e.stopPropagation();

            let quantity = parseInt(this.quantityAmount.value);
            this.updateQuantity(quantity);
        });
    }

    async updateQuantity(quantity) {
        this.toggleLoading();
        let response = await fetch(`/cart/change.js`, { 
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                quantity: `${quantity}`,
                id: this.dataset.id
            })
        });
        this.toggleLoading();
        let data = await response.json();
        this.cart.refreshCart();
    }

    async remove() {
        this.toggleLoading();
        let response = await fetch(`/cart/change.js?quantity=0&id=${this.dataset.id}`, { method: 'POST' });
        this.toggleLoading();
        let data = await response.json();
        this.cart.refreshCart();
    }

    toggleLoading() {
        this.classList.toggle('custom-slide-cart-item__loading');
    }

}
customElements.define('custom-slide-cart-item', CustomSlideCartItem);
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};